export default __webpack_public_path__ + "static/media/aluminum_scrap.0fcd5bc0.png";